export default __webpack_public_path__ + "static/media/gym-res.602d51fe.svg";